import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pick, prop } from 'ramda';
import { getCleanUrl, getURLParams } from 'js/utils/url.util';
import { useAppSelector, usePageSelector } from 'js/store/hooks';

import { useTriggerCondition } from '../../Emitter';
import { getBasicCondition } from '../../../helpers';
import { BASIC_TAG_LAUNCH_CONDITION } from '../../../constants';

export const useTriggerBeforePageRendered = () => {
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const { isPageRendering, friendlyURL, path } = usePageSelector(pick(['isPageRendering', 'friendlyURL', 'path']));
    const triggerCondition = useTriggerCondition();
    let page = friendlyURL || path && getCleanUrl(path);

    if (page === '/') {
        page = rootPage;
    }

    useEffect(() => {
        if (page && isPageRendering) {
            triggerCondition(getBasicCondition({
                launch: BASIC_TAG_LAUNCH_CONDITION.beforePageRendered,
                page,
                urlParams: getURLParams(location.search)
            }));
        }
    }, [isPageRendering, triggerCondition, page, location.search]);
};
